/* userInterface */
import request from '@/utils/request.js'

/** Customer Auth V3. Phone/email are identifiers; password and Google are methods. */
export const V3PasswordLoginReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/password',
  data
})

export const V3GoogleLoginReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/google',
  data
})

export const V3ChallengeReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/challenges',
  data
})

export const V3ChallengeVerifyReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/challenges/verify',
  data
})

export const V3GetProfileReq = () => request({
  method: 'GET',
  url: '/customerapi/V3/sso/profile'
})

export const V3UpdateProfileReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/profile',
  data
})

export const V3IdentitiesReq = () => request({
  method: 'GET',
  url: '/customerapi/V3/sso/identities'
})

export const V3UpdatePasswordReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/password/update',
  data
})

export const V3StoreTokenReq = (data) => request({
  method: 'POST',
  url: '/customerapi/V3/sso/storetoken',
  data
})

/** Get user credits and balance for specific store **/
export const GetCreditsReq = (cafe_id) => {
  return request({
    method: 'GET',
    url: '/customerapi/V3/sso/credits',
    params: { cafe_id }
  })
}

/** Get cafe information (name, logo) **/
export const GetCafeInfoReq = (cafe_id) => {
  return request({
    method: 'GET',
    url: '/customerapi/V3/sso/cafe',
    params: { cafe_id }
  })
}

/** Current signed-in customer only; claims never control authentication success. */
export const V3ClaimsReq = (cafe_id) => request({
  method: 'GET',
  url: '/customerapi/V3/sso/claims',
  params: cafe_id ? { cafe_id } : undefined
})
